import {
	MessageToAdminConstants
}from "./constans"
import api from './api'
import {
	defAction
}from "../../helpers/defaultAction"

export const messageToAdminAction = {
	adminLookedMessage,
	getItems,
	setAnswerFromAdmin,
	setMessageFromUser,
	sendMessageToSpam,
	sendMessagesListToSpam
}

function getItems(params){
	const dispatchObj = {
		constants : MessageToAdminConstants.GetItems,
		service   : {
			func   : api.getItems,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function setMessageFromUser(params){
	const dispatchObj = {
		constants : MessageToAdminConstants.SetMessage,
		service   : {
			func   : api.setMessageFromUser,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function setAnswerFromAdmin(params){
	const dispatchObj = {
		constants : MessageToAdminConstants.SetMessage,
		service   : {
			func   : api.setAnswerFromAdmin,
			params : params
		}
	}
	return defAction(dispatchObj)
}
function adminLookedMessage(params){
	const dispatchObj = {
		constants : MessageToAdminConstants.adminLookedMessage,
		service   : {
			func   : api.adminLookedMessage,
			params : params
		}
	}
	return defAction(dispatchObj)
}
function sendMessageToSpam(params){
	const dispatchObj = {
		constants : MessageToAdminConstants.sendMessageToSpam,
		service   : {
			func   : api.sendMessageToSpam,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function sendMessagesListToSpam(params){
	const dispatchObj = {
		constants : MessageToAdminConstants.sendMessagesListToSpam,
		service   : {
			func   : api.sendMessagesListToSpam,
			params : params
		}
	}
	return defAction(dispatchObj)
}